module.exports = __webpack_public_path__ + "static/dax-e9fe8ebbc72a7c15bf6f1d4245027c43.png";